import { render } from "./LineUsers.vue?vue&type=template&id=df2ff278&scoped=true"
import script from "./LineUsers.vue?vue&type=script&lang=ts"
export * from "./LineUsers.vue?vue&type=script&lang=ts"

import "./LineUsers.vue?vue&type=style&index=0&id=df2ff278&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-df2ff278"

export default script
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QTr,QTh,QTd,QSpace});
